export default __webpack_public_path__ + "static/media/Fighting.5ec47727.svg";